export const title = {
  zh: '艾修美保（Assura Asia）服务使用条款',
  en: 'Assura Asia Terms of Service',
  jp: 'Assura Asia サービス利用規約',
  kr: 'Assura Asia 서비스이용약관',
}

export const date = {
  zh: '本版生效日期：2025年1月1日',
  en: 'Effective Date of This Version: [01/01/2025]',
  jp: '施行日：2025年1月1日',
  kr: '시행일자: 2025년1월1일',
}

export const content = {
  zh: `<b>${title.zh}</b>
  
  ${date.zh}

  感谢使用本保险经纪平台服务（以下简称“本服务”）：
保险经纪平台服务协议（以下简称“本协议”）是艾修美保（Assura Asia）与用户（以下简称“您”）就保险经纪平台服务相关事项所订立。本协议有助于您了解我们为您提供的服务内容及您的权利和义务。
请您仔细阅读本协议中已加粗的相关条款，这些条款可能对您接受本服务较为重要，特别提醒您加以注意，您使用本服务、通过网络页面点击确认或以其他方式接受本协议，即视为您已充分理解本协议所有条款，并同意与我们订立本协议。如您在同意订立本协议之前，对本协议内容存在疑患或异议，请联系我们，以便我们为您进行解释和说明，使您能够充分理解，从而帮助您自主决定是否接受本协议及是否使用我们的服务。

<b>一、相关定义</b>
除非本协议另有约定，本协议下列术语定义如下：
保险经纪平台指由我们提供的全球化服务平台，用于展示、查询和销售国家及地区的保险产品，传递投保意向，采集投保信息，支持用户与保险机构进行信息交互，并提供多样化的保险相关服务。
保险机构指依法经各国或地区的保险监管机构批准设立，并完成合法注册的商业保险公司，向用户提供保险产品或相关服务。
投保指用户通过本平台特定国家/地区的保险机构提交购买保险产品申请的行为。
承保指保险机构在收到用户的投保申请后，根据适用的法律和法规，经审核同意与用户订立保险合同，并按照合同约定履行相应的保险责任的行为。

<b>二、保险经纪平台服务</b>
我们提供的保险经纪平台服务包括如下内容
1.产品展示与购买
您可以通过平台获知各保险相关的产品报价，并可直接向平台对投保进行申请，以完成保险购买。
2.出险报案
若发生保险事故，您可通过保险经纪平台提供的报案路径将出险情况通知保险机构，进行理赔报案。
3.其他服务
参与保险机构或其他主体提供的各类增值服务和活动。

<b>三、声明与承诺</b>
1、您登录后发出的指令将视为您本人所为，所以特别提醒您，请妥善保管登录的认证要素，不要将其提供给任何第三方或交于任何第三方使用。为提高服务安全性，我们或我们的合作机构可能采取必要手段对您进行身份验证，并据此决定为您提供服务的种类、范围及进行业务操作的权限。为保障您的资金安全，我们将根据您的账户类别、身份认证措施、交易风险度等因素的不同，设定不同的安全策略。
2.您承诺不为任何非法目的或以任何非法方式使用本服务，并承诺遵守中国相关法律、法规及互联网之使用惯例。如我们发现或经第三方举报并经核实您存在前述行为或情形，我们可能会暂停或终止全部或部分服务，并视需要报告监管部门，并可能依法移送司法机关。
3.您承诺对由您发布、确认、上传、寄送或者以其他方式提供的资料、信息或文件享有合法权利，未侵犯也不会侵犯任何其他方的合法权利或权益（包括隐私权、商标权、专利权等）。在您为他人投保时，已经取得他人许可，且通过保险经纪平台提供的被保险人信息已经过被保险人的授权同意。

<b>四、免责与风险提示</b>
1.您理解并同意，保险合同的缔结和履行由您和保险机构共同合意完成。我们建议您，在保险合同缔约前审慎选择保险机构和保险产品，在保险合同履行过程中关注和促使保险机构完整履行保险合同的各项义务。
2.您理解并同意，我们因市场变化或业务调整等原因可能会变更、暂停、终止与保险机构的合作，据此您可能无法通过保险经纪平台接受保险机构的服务或购买产品。您可以线下与保险机构联系接受服务或购买产品。
3.若出现因系统自身原因、系统差错、故障或其他原因引发的展示延误、错误或者您不当获利等情形的，您同意我们可以采取更正差错、暂停服务等适当纠正措施。
4.您知晓并同意，您接受本服务时可能面临如下风险和损失：
（1）监管风险：有关法律、法规及相关政策、规则发生变化，导致无法购买某些保险产品或获取某些服务，您由此可能遭受损失；
（2）违约风险：极端情况下保险机构可能因无力或其他原因不能履约，导致您遭受损失；
（3）成交风险：您所投保的保险产品无法承保，您由此无法获得保险保障及服务；
（4）过错风险：您的决策失误、操作不当、遗忘或泄露账户密码、密码被他人破解、您使用的计算机或设备系统被第三方侵入、您委托他人代理交易时他人恶意或不当操作，可能给您造成损失；
（5）本协议约定的有限责任及不可抗力因素导致的风险
5.请您知晓，本服务中产品的展示如为保险机构配置、提供、上传信息的，各类信息查询结果应以保险机构系统记载的数据为准。您在做出投保决策前，应全面了解相关产品情况，谨慎决策。您与保险机构之间发生的纠纷，应当依据法律规定各自承担风险及责任。在必要的情况下，我们可以为您提供必要的协助。

<b>五、有限责任</b>
因下列状况导致您无法使用本服务时，我们不承担除法律有明确规定外的责任。
1.系统停机维护或升级；
2.本服务所依赖的电信设备出现故障；
3.因台风、地震、海啸、洪水、雷电、停电、战争或恐怖袭击、罢工、新冠肺炎等不可抗力原因；
4.您的电脑软件、系统、硬件和通信线路、供电线路出现故障；
5.用户操作不当或通过非授权或认可的方式使用本服务；
6.因病毒、木马、恶意程序攻击、网络拥堵、系统不稳定、系统或设备故障、通讯故障、银行原因、第三方服务失败或政府行为等原因；
7.其他不可归因于我们的原因

<b>六、信息收集、使用、共享与保护</b>
我们重视对您的隐私的保护，保护用户信息及隐私是我们的一项基本原则。我们将按照《艾修美保隐私政策》收集、存储、保护、使用及对外提供您的信息。保险经纪平台的所有服务均适用本规则，除非相关服务已有独立的隐私权政策或相应的用户服务协议当中存在特殊约定。请您使用相关服务之前，务必充分阅读该规则所有条款。如您对该规则内容及页面提示信息有疑问，请您暂停后续操作，您可以通过该规则所公布的信息处理者的联系方式进行咨询，以使我们为您解答和说明。

<b>七、协议变更、解除、终止和权利义务的转让</b>
1.协议变更
我们可以根据市场变化或经营的需要对本协议进行调整，本协议调整后会以公告或站内信形式通知，公告发布之日起第7个自然日后协议生效。
若您不同意修改本协议，则应当立即停止使用本服务或通过客服解除本协议；否则，视为您同意并接受修改后的协议。
2.协议解除与终止
2.1您在使用本服务的过程中，如果有下列情形发生，我们可以单方面解除本协议：
2.1.1冒用他人名义、盗用他人账户使用本服务的；
2.1.2为非法目的使用保险本服务的；
2.1.3从事任何可能侵害平台系统、资料之行为；
2.1.4违反任何法律法规、本协议约定的；
2.1.5监管机构认为平台提供的服务不再符合相关监管规定的；
2.2除上述原因外，我们可以根据风险及自身业务运营情况需要终止向您提供某些服务，届时我们将会视情况公告或告知。鉴于这属于正常商业决策行为，如因此导致您无法使用本服务或服务受到限制的，您理解我们无须对此承担责任。
2.3权利义务的转让：我们可以根据本服务的需要，变更或增加履约主体，如您继续使用本服务的，视为同意变更后的主体或新增的主体作为与您履约的相对方。在不对您使用本服务造成不利影响的前提下，我们可将在本协议项下的权利和义务全部或部分转让给第三方，而无需另行通知或征得您的同意。

<b>八、争议的解决</b>
本协议的订立、效力、解释、履行及争议的解决应依据适用法律。在协议履行期间，凡因本协议引起或与本协议相关的任何争议或纠纷，各方应首先通过友好协商解决。若协商未果，各方一致同意依据适用法律，将争议提交至被告所在地或双方约定的具有管辖权的法院或仲裁机构解决。

<b>九、通知</b>
本协议履行过程中，我们向您发出的书面通知方式包括邮寄纸质通知、平台内公告、电子邮件、站内信、手机短信等方式。如我们以邮寄方式向您发出书面通知的，则在我们按照您在我们平台留存的通讯地址交邮后的第3个自然日即视为送达。如以平台内公告、保险相关公告、电子邮件、手机短信等电子方式发出书面通知的，则通知发送成功即视为送达。

<b>十、其他</b>
1、在本协议中，除非本协议上下文另有规定：
凡提及本协议应包括本协议及其附件，以及对该协议所作的任何修改、修订或补充的文件；
凡提及条、款和附件仅指本协议的条、款和附件。
2.本协议条款的标题仅为查阅方便而设置，不应构成对本协议的任何解释，不对标题之下的内容及范围作任何限定。
3.本协议的附件及各项补充、修订或变更，为本协议不可分割的组成部分，与本协议正文具同等法律效力。`,
  
  en: `<b>${title.en}</b>
  
  ${date.en}

  Thank you for using our insurance brokerage platform services (hereinafter referred to as the "Services"):
This agreement (hereinafter referred to as the ""Agreement"") is entered into between Assura Asia ("we", "our" or "us"") and the user ("you" or "your") regarding matters related to the use of our insurance brokerage platform. This Agreement is designed to help you understand the services we provide, as well as your rights and obligations.
Please carefully review the terms highlighted in bold, as they may significantly impact your rights. By using the Services, clicking to confirm, or otherwise accepting this Agreement, you acknowledge that you have fully understood all terms and agree to enter into this Agreement with us. If you have questions or concerns before agreeing to this Agreement, please contact us for clarification to help you make an informed decision.

1. Definitions
Unless otherwise specified, the following terms have the meanings set forth below:
Insurance Brokerage Platform: A global service platform provided by us for displaying, querying, and purchasing insurance products, submitting insurance applications, collecting insurance information, facilitating interactions between users and insurance institutions, and providing various insurance-related services.
Insurance Institution: A commercial insurance company legally established and registered under the approval of relevant national or regional insurance regulatory authorities, providing insurance products or services to users.
Application for Insurance: The act of submitting an application through the platform to purchase insurance products from a specific insurance institution.
Underwriting: The act by which an insurance institution, upon receiving a user's application for insurance, agrees to enter into an insurance contract and fulfills the corresponding insurance responsibilities in accordance with applicable laws and regulations.

2. Insurance Brokerage Platform Services
We provide the following services through the platform:
2.1 Product Display and Purchase
You can access insurance product quotes through the platform and directly apply for insurance to complete your purchase.
2.2 Claims Reporting
In the event of an insurance incident, you can notify the relevant insurance institution of the claim through the platform’s reporting channels.
2.3 Other Services
You may participate in additional value-added services or activities provided by insurance institutions or third parties via the platform.

3. Declarations and Commitments
3.1 Account Security
You are responsible for safeguarding your login credentials. Actions performed after login are deemed to be your own. For security purposes, we or our partners may verify your identity and determine the types and scope of services provided. Security measures will be based on your account type, identity verification level, and associated risks.
3.2 Lawful Use
You agree not to use the Services for unlawful purposes and to comply with all applicable laws and internet usage norms. If violations are identified or reported and confirmed, we may suspend or terminate some or all of the Services and report the matter to relevant authorities as necessary.
3.3 Legal Rights
You affirm that you hold legal rights to any materials or information you submit through the platform and that such submissions do not infringe on others’ rights (e.g., privacy, trademarks, patents). For third-party insurance applications, you confirm that you have obtained the necessary permissions from the insured party.

4. Disclaimers and Risk Warnings
4.1 Contractual Relationship
The conclusion and performance of insurance contracts are solely between you and the insurance institution. Before entering into an insurance contract, carefully select institutions and products and monitor their fulfillment of contractual obligations.
4.2 Service Limitations
We may adjust, suspend, or terminate cooperation with insurance institutions due to market or business changes, potentially affecting access to certain services or products via the platform.
4.3 System Errors
In case of errors, delays, or inaccuracies caused by system issues, we may take corrective actions, such as suspending services, without bearing liability for resulting losses.
4.4 Risks
By using the Services, you acknowledge and accept potential risks, including but not limited to:
Regulatory Risks: Changes in laws, regulations, or policies may impact access to certain insurance products or services.
Default Risks: Insurance institutions may fail to fulfill obligations under extreme circumstances.
Operational Risks: Errors in your decisions, actions, or system security may lead to losses.
Force Majeure: Unforeseeable events such as natural disasters or government actions.

5. Limitation of Liability
We are not liable for service interruptions or losses resulting from:
Scheduled system maintenance;
Failures of telecommunications or related equipment;
Force majeure events, such as natural disasters or pandemics;
User-side errors, such as misuse or security breaches;
Third-party service failures or government actions.

6. Information Collection, Use, Sharing, and Protection
We prioritize protecting your privacy. The collection, storage, use, and sharing of your information are governed by the Assura Asia Privacy Policy. Please review the policy to understand how we handle your data. For questions, contact us before proceeding with the Services.

7. Changes, Termination, and Transfer of Agreement
7.1 Amendments
We may modify this Agreement based on business needs. Changes will take effect seven days after notification via announcement or internal messaging. If you disagree, discontinue using the Services; otherwise, continued use constitutes acceptance.
7.2 Termination
We may terminate this Agreement under the following circumstances:
Fraudulent or unauthorized account use;
Illegal use of the Services;
System attacks or violations of the Agreement;
Regulatory non-compliance.
7.3 Transfer of Rights and Obligations
We may transfer rights or obligations under this Agreement to third parties without requiring additional consent, provided it does not adversely affect your use of the Services.

8. Dispute Resolution
Disputes arising from this Agreement will be resolved through good-faith negotiations. If unresolved, disputes shall be submitted to a court or arbitration body with jurisdiction as determined by applicable law.

9. Notifications
Notices will be sent via postal mail, platform announcements, email, or SMS. Postal notices are deemed delivered on the third day after dispatch; electronic notices are deemed delivered upon successful transmission.

10. Miscellaneous
This Agreement includes its attachments and any revisions, all of which have equal legal effect.
Section headings are for reference only and do not limit the scope or interpretation of the provisions.
Attachments and supplementary terms form an integral part of this Agreement.`,

  jp: `<b>${title.jp}</b>
  
  ${date.jp}

  Assura Asia が提供する保険仲介プラットフォームサービス（以下「本サービス」）をご利用いただき、ありがとうございます。
本利用規約（以下「本規約」）は、Assura Asia （以下「当社」）とお客様（以下「お客様」）との間で、本サービスに関する利用条件を定めたものです。本規約は、お客様に本サービスの内容やお客様の権利・義務を分かりやすく理解していただくことを目的としています。
本規約に記載されている太字で強調された条項は、特に重要な内容であり、お客様にとって重要な規定を含んでいますので、十分にご確認のうえお読みいただいてください。お客様が本サービスを利用される際、ウェブページ上で確認ボタンをクリックする、またはその他の方法で本規約に同意された場合、お客様は本規約のすべての条項を理解し、同意したものとみなされます。万が一、本規約にご不明点や異議がある場合は、同意前に当社までご連絡いただき、内容をご理解いただいたうえで、本規約に同意するか、本サービスを利用するかをご判断ください。

一、用語の定義
本規約において、特段の定めがない限り、以下の用語は次の意味を有します：
１保険仲介プラットフォーム当社が提供するグローバルサービスプラットフォームを指し、各国および地域の保険商品を展示、検索、販売するために使用されます。また、保険加入の意向を伝え、保険情報を収集し、ユーザーと保険機関の間で情報をやり取りすることをサポートします。さらに、多様な保険関連サービスを提供します。
２保险機関
各国・地域の保険監督管理保険機関
によって認可を受け、合法的に商業登記された、保険商品や関連サービスを提供する商業保険機関を指します。
３、保険加入
本サービスを通じて、お客様が世界各国または特定の国や地域の保険会社に保険商品の申し込みを行う行為を指します。
４、引受保険会社がお客様からの申込みを受け付けた後、適用される法律や規制に基づき審査を行い、契約締結を承諾し、保険契約に基づく責任を履行する行為を指します。

二、保険仲介プラットフォームサービス
当社が提供する保険仲介プラットフォームサービスには、以下の内容が含まれます
1.商品表示および購入
プラットフォームを通じて各保険商品の見積もりを確認し、直接申し込みを行うことで保険購入を完了することができます。
2.保険事故の報告
万が一、保険事故が発生した場合、保険仲介プラットフォームを通じて保険機関に報告し、損害賠償請求の手続きを行うことができます。
3.その他のサービス
保険機関またはその他の提供者による各種の付加価値サービスやイベントにご参加いただけます。

三、声明および約束
1、お客様がログイン後に発した指示は、すべてお客様本人によるものであるとみなされます。したがって、ログイン認証情報を適切に管理し、第三者に提供したり使用させたりしないようご注意ください。サービスの安全性を向上させるため、当社または提携先は必要な手段でお客様の本人確認を行い、その結果に基づいて、提供するサービスの種類、範囲、および業務操作の権限を決定します。資金の安全を確保するため、アカウントの種類、本人確認の手段、取引リスクなどの要因に応じて、異なるセキュリティポリシーを設定します。
2.お客様は、いかなる違法目的や違法な方法で本サービスを使用しないことを約束し、また中国の関連法規やインターネット使用の慣行を遵守することを約束します。もし、当社または第三者からの通報により、お客様が前述の行為または状況を行っていることが確認された場合、当社はサービスの一部または全部を停止または終了し、必要に応じて監督機関に報告し、司法機関に引き渡すことがあります。
3.お客様は、ご自身が発信、確認、アップロード、送信、またはその他の方法で提供する資料、情報、または文書に合法的な権利を有し、他者の合法的な権利（プライバシー権、商標権、特許権など）を侵害しないことを約束します。また、他人のために保険を契約する場合、その人から許可を得ており、提供された被保険者情報は被保険者の同意を得たものであることを確認します。

四、免責事項およびリスクの提示
1.お客様は、保険契約の締結と履行が、お客様と保険機関との合意に基づいて行われることを理解し、同意します。保険契約を締結する前に保険機関と保険商品を慎重に選択し、契約履行中には保険機関が保険契約に基づく義務を完全に履行することを確認するよう努めることをお勧めします。
2.市場の変動や業務の調整などにより、当社は保険機関との提携を変更、停止、または終了することがあります。この場合、お客様は保険仲介プラットフォームを通じて保険機関のサービスを受けられない場合がありますが、直接保険機関と連絡を取ることでサービスを受けたり、商品を購入したりすることができます。
3.システムの内部原因、エラー、故障、またはその他の理由により、表示の遅延、誤り、または不正な利益を得た場合、当社は誤りの訂正やサービスの停止など、適切な修正措置を講じることに同意します。
4.本サービスを受ける際に以下のようなリスクや損失が発生する可能性があることを理解し、同意します：
（1）規制リスク：法律、規制、関連政策、ルールの変更により、特定の保険商品やサービスを購入できなくなる場合；
（2）契約不履行リスク：極端な状況下、保険会社が財務的な理由やその他の事情により契約履行ができなくなった場合；
（3）契約成立リスク：お客様が選択した保険商品が承認されない場合、保険保障やサービスを受けられない可能性があります；
（4）過失リスク：お客様の判断ミス、操作ミス、アカウント情報の管理不十分（パスワードの忘れや漏洩など）、第三者によるパスワードの不正取得、または使用中のデバイスへの不正アクセスなどにより、損害が発生する可能性があります。また、お客様が他者に取引を委託した場合、その代理人による不正操作や意図的な行為が原因で損害を被ることもあります；
（5）責任制限および不可抗力によるリスク
5.本サービスにおける保険商品情報が保険機関によって提供されたものである場合、情報の正確性は保険機関のシステムに記録されたデータを基に判断されます。加入される前に関連情報を十分に確認し、慎重に決定してください。保険機関との間で生じた紛争は、法律に基づき各自がリスクおよび責任を負うものとします。必要に応じて、当社は必要な支援を提供することがあります。

五、責任制限
以下の事由により本サービスがご利用いただけない場合、法律に特別な規定がない限り、当社は責任を負いません。
1.システムメンテナンスやアップグレードによるサービスの一時停止；
2.サービス依存の通信設備やシステム障害；
3.台風、地震、津波、洪水、雷、停電、戦争、テロ、ストライキ、COVID-19など、不可抗力によるサービス提供の遅延や中断；
4.お客様のコンピュータ、ソフトウェア、システム、ハードウェア、通信回線、電力供給回線の故障；
5.お客様による不適切な操作や認可されていない使用；
6ウイルス、マルウェア、悪意のあるプログラムによる攻撃、ネットワーク混雑、システム不安定、システムまたは設備の故障、通信障害、銀行の問題、第三者サービスの失敗、政府の措置等；
7.その他、当社に起因しない事由

六、情報の収集・利用・保護
お客様のプライバシー保護を大切にしており、ユーザー情報やプライバシーの保護は当社の基本的な方針です。当社は「Assura Asia プライバシーポリシー」に基づき、お客様の情報を収集、保存、保護、利用し、必要に応じて外部提供を行います。保険仲介プラットフォームの全てのサービスには本規則が適用されますが、特定のサービスについては、独立したプライバシーポリシーやユーザーサービス契約に特別な定めがある場合、それらが優先されます。

サービスをご利用いただく前に、ぜひ本規則の内容をよくご確認ください。本規則や画面上の注意事項についてご不明な点がある場合は、操作を一旦中断いただき、本規則内で案内している情報管理者の連絡先までお気軽にお問い合わせください。丁寧にご説明させていただきます。

七、契約の変更・解除・終了および譲渡
1.契約の変更
当社は、事業運営上の必要や市場の変動に応じて、本契約を変更することがあります。契約変更時は、サイト内のお知らせまたはメッセージにてご案内し、変更通知後7日目より効力が生じます。
変更にご同意いただけない場合は、速やかにサービスの利用を停止し、カスタマーサポートを通じて契約を解除することが可能です。それ以外の場合は、変更後の契約内容に同意したものとみなされます。
2.契約の解除および終了
2.1本サービスの利用中に、以下のいずれかの状況が発生した場合、当社は本契約を一方的に解除することができます：
2.1.1他人の名義を不正に使用した場合、または他人のアカウントを不正に利用した場合；
2.1.2本サービスを不正な目的で利用した場合；
2.1.3 プラットフォームのシステムやデータに対して不正な行為を行った場合；
2.1.4法令または本契約に違反した場合；
2.1.5監督機関が、当社が提供するサービスが規制に適合しないと判断した場合；
2.2上記以外の場合でも、当社はリスク管理や事業運営の都合により、サービスの提供を終了することがあります。この場合、適宜、通知や告知を行いますが、サービスの提供停止または制限について、当社は責任を負いません。
2.3権利義務の譲渡：当社は、本サービスの運営に必要な場合、契約履行の主体を変更・追加することがあります。お客様が引き続き本サービスを利用する場合、変更後または新たな主体との契約を承諾したものとみなされます。また、当社は、サービス提供に影響を及ぼさない範囲で、本契約に基づく権利や義務を第三者に譲渡することができ、その際にお客様の同意を得る必要はありません。

八、紛争の解決
本契約の締結、効力、解釈、履行および紛争の解決については、中華人民共和国の法律が適用されます。本契約の履行期間中、本契約に起因または関連するすべての紛争や争いについて、当事者はまず協議を行い、解決を図るものとします。協議による解決ができない場合、双方は被告の所在地の人民法院（裁判所）に提起された訴訟によって解決することに同意するものとします。

九、通知
本契約に基づく通知は、以下の方法で行うものとします：郵送、プラットフォーム内の掲示、電子メール、メッセージ、SMS（ショートメッセージ）など。郵送による通知の場合、当社がお客様の登録住所に発送した日から3日後に、通知が到達したものとみなします。プラットフォーム内の掲示、保険関連のお知らせ、電子メール、SMSなどの電子的手段による通知の場合、送信完了時点で通知が到達したものとみなされます。

十、その他
1.本契約において、特に文脈に別段の定めがない限り：
「本契約」とは、本契約書本体およびその付属書類、ならびにその後の変更、修正、補充を含むものとします；
また、「条文」や「項目」、「付属書類」とは、いずれも本契約における条文、項目および付属書類を指すものとします。
2.本契約における各条項の見出しは、参照を容易にするために設けたものであり、契約の解釈に影響を及ぼすものではなく、見出しに基づいて内容や範囲が制限されることはありません。
3.本契約の付属書類およびその補充、修正、変更は、本契約の一部として不可分であり、契約本体と同等の法的効力を有します。`,

  kr: `<b>${title.kr}</b>
  
  ${date.kr}
  
  본 보험 중개 플랫품 서비스(이하 “서비스”로 통칭함)를 이용해 주셔서 감사합니다.
이 서비스이용약관(이하 “약관”으로 통칭함)은 Assura Asia 와 Assura Asia 를 사용하는 고객(이하 “고객”으로 통침함)이 보험 중개 플랫폼 서비스를 바탕으로 체결된 것입니다. 이 약관은 회사가 고객에게 제공하는 서비스와 고객의 권리 및 의무를 이해하는 데 도움이 됩니다.
이 약관은 고겍이 서비스를 사용하는 데 매우 중요한 것으로 굵게 강조 표시된 관련 사항을 꼭 자세히 읽어 주시기 바랍니다. 특별히 주의해야 할 점은 서비스를 이용하거나 웹 사이트에 확인 버튼을 클릭하거나 별도의 방식으로 이 약관을 수락한 경우, 고객은 이 약관의 모든 조항을 완전히 이해했으며 회사와 이 약관을 체결하는 데 동의한 것으로 간주됩니다. 이 약관 체결에 동의하기 전에 이 약관의 내용에 대해 의문이나 이의가 있는 경우 회사에 연락해 주시고 회사의 설명 및 예시를 통해 충분히 이해하여 이 약관에 동의할지 여부 및 회사 서비스 이용 여부를 스스로 결정할 수 있도록 도움을 받으시기 바랍니다.

제1조 정의
이 약관에 별도의 규정이 없는 한, 계약에서 나온 용어의 정의는 다음과 같습니다.
  1. 보험 중개 플랫폼
  회사가 제공하는 글로벌화된 서비스 플랫폼을 말합니다. 국가 및 지역 보험 상품의 전시, 조회 및 판매, 보험 가입 의사 전달, 보험 가입 정보 수집, 이용자와 보험 기관 간의 정보 교류 지원, 또한 다양한 보험 관련 서비스 제공을 위해 사용하는 것입니다.
  2. 보험 기관 
  각 국가 또는 지역의 보험 규제 당국의 승인을 받아 설립되고 합법적으로 등록된 상업 보험 회사를 말하며, 고객에게 보험 상품 또는 관련 서비스를 제공합니다.
  3. 보험 가입
  고객이 회사 플랫폼의 특정 국가/지역의 보험 기관을 통해 보험 상품 구매를 위한 신청을 제출하는 행위를 의미합니다.
  4. 보험 인수 
  보험 기관이 고객의 보험 가입 신청을 접수한 후 관련 법령에 따라 심사 및 승인을 거쳐 고객과 보험 계약을 체결하고 계약에 따라 해당 보험 책임을 이행하는 행위를 말합니다.

제2조 서비스의 제공
회사가 제공하는 보험 중개 플랫폼 서비스는 다음과 같이 포함됩니다.
  1. 상품 전시 및 구매
  플랫폼을 통해 각종 보험 상품의 견적을 확인할 수 있으며, 보험 가입을 위해 직접 신청하여 구매를 완료할 수 있습니다.
  2. 사고 신고
  보험 사고 발생 시 보험 중개 플랫폼에서 제공하는 신고 경로를 통해 보험기관에 사고 사실을 알리고 보험금 청구를 진행할 수 있습니다.
  3. 기타 서비스
  보험사 또는 기타 주체가 제공하는 다양한 부가 서비스 및 활동에 참여할 수 있습니다.

제3조 선언 및 약속
  1. 고객이 로그인 후 발급된 지침은 고객 본인이 한 것으로 간주되므로 로그인 인증 요소를 타당하게 보관하고 이를 제3자에게 제공하거나 제3자가 사용하도록 양도하지 않도록 각별히 주의하시기 바랍니다. 회사 서비스의 보안을 강화하기 위해 회사 또는 회사의 파트너사는 고객의 신분을 확인하기 위해 필요한 수단을 취할 수 있으며, 이에 따라 서비스의 종류와 범위 및 업무 수행 권한을 고객에게 제공하기로 결정할 수 있습니다. 회사는 고객의 자금의 안전을 보호하기 위해 고객의 계좌 유형, 본인 인증 조치, 거래 위험도 및 기타 요인에 따라 다양한 보안 전략을 수립할 것입니다.
  2. 고객은 이 서비스를 불법적인 목적이나 불법적인 방법으로 사용하지 않을 것을 약속하며, 관련 중국 법률, 규정 및 인터넷 사용 관행을 준수할 것을 약속합니다. 회사는 고객이 앞서 언급한 행위나 상황을 발견하거나 제3자에 의해 신고되어 확인된 경우 서비스의 전부 또는 일부를 중단 또는 종료할 수 있으며, 필요에 따라 규제 당국에 신고하고 법에 따라 사법 당국에 회부할 수 있습니다.
  3. 고객은 본인이 게시, 확인, 업로드, 전송 또는 기타 방식으로 제공한 데이터, 정보 또는 문서에 대한 법적 권리를 갖고, 다른 제3자의 법적 권리 또는 이익(프라이버시, 상표권, 특허권 등 포함)을 침해하지 않았으며 앞으로도 침해하지 않을 것임을 약속합니다. 고객이 타인을 보험 가입하는 경우 해당 사람의 동의를 얻어 또한 보험 중개 플랫폼을 통해 피보험자의 정보를 제공하는 것에 대해 피보험자의 동의를 얻어야 합니다.

제4조 면책 조항 및 위험 경고
  1. 고객은 보험계약의 체결 및 이행이 고객과 보험기관의 상호 합의에 의해 이루어짐을 이해하고 동의합니다. 보험계약 체결 전에 보험기관 및 보험상품을 신중하게 선택하고, 보험계약의 이행 과정에서 보험기관이 보험계약상의 의무를 충분히 이행할 수 있도록 각별히 주의하고 촉구할 것을 권장합니다.
  2. 시장 변화 또는 사업 조정 등의 이유로 회사가 보험기관과의 협력을 변경, 중단 또는 종료할 수 있으며, 이에 고객은 보험중개 플랫폼을 통해 보험기관으로부터 서비스를 제공받거나 상품을 구매하지 못할 수 있음을 이해하고 동의하시기 바랍니다. 고객은 오프라인으로 보험대리점에 연락하여 서비스를 제공받거나 상품을 구매할 수 있습니다.
  3. 시스템 자체, 시스템 오류, 장애, 혹은 기타 사유로 인해 표시가 지연 또는 오류가 발생하거나 고객이 부당한 혜택을 받은 경우, 고객은 회사가 오류의 정정, 서비스 중단 등 적절한 시정 조치를 취할 수 있음에 동의합니다.
  4. 고객은 서비스를 수락할 때 다음과 같은 위험과 손실에 노출될 수 있음을 인지하고 이에 동의합니다.
  (1) 규제 위험: 관련 법률, 규정 및 관련 정책과 규칙의 변경으로 인해 특정 보험 상품을 구매하거나 특정 서비스를 제공받지 못할 수 있으며, 이로 인해 손실을 입을 수 있습니다.
  (2) 위약 위험: 극단적인 경우에 보험기관이 무능력 또는 기타 사유로 인해 보험 업무를 수행하지 못할 수 있으며, 이로 인해 고객에게 손실이 발생할 수 있습니다.
  (3) 거래 위험: 고객이 가입한 보험 상품이 인수되지 않아 결과적으로 보험 보장 및 서비스를 받지 못할 수 있습니다.
  (4) 과실 위험: 고객의 잘못된 의사 결정, 부적절한 조작, 계정 비밀번호의 분실 또는 노출, 타인에 의한 비밀번호의 해독, 고객이 사용하는 컴퓨터 또는 장비 시스템의 제3자 침입, 타인에게 거래의 대리인 역할을 맡긴 경우 타인의 악의적이거나 부적절한 조작으로 인해 손실을 입을 수 있습니다.
  (5) 본 약관에서 합의한 제한 책임 및 불가항력적 요인으로 인한 위험
  5. 이 서비스 내의 상품 전시가 보험기관에 의해 구성, 제공 또는 업로드된 경우, 각종 정보 조회 결과는 보험기관의 시스템에 기록된 데이터에 기준으로 활용됨을 유의하시기 바랍니다. 고객은 보험 가입을 결정하기 전에 관련 상품을 충분히 이해하고 신중하게 결정해야 합니다. 고객과 보험기관 간의 분쟁은 법률에 따라 각자의 위험과 책임에 따릅니다. 필요한 경우 회사는 고객에게 필요한 지원을 제공할 수 있습니다.

제5조 책임 제한
다음과 같은 상황으로 인해 고객이 서비스를 이용할 수 없는 경우, 회사는 법률에 명시적으로 규정된 경우를 제외한 책임을 지지 않습니다.
  1. 시스템 유지보수 또는 업그레이드로 인한 다운타임
  2. 서비스가 의존하는 통신 장비의 고장
  3. 태풍, 지진, 쓰나미, 홍수, 번개, 정전, 전쟁 또는 테러 공격, 파업, 코로나19와 같은 불가항력적인 사유
  4. 컴퓨터 소프트웨어, 시스템, 하드웨어 및 통신 회선, 전원 공급 선로의 고장
  5. 사용자의 부적절한 조작 또는 승인되지 않거나 인정되지 않은 수단을 통한 서비스 사용
  6. 바이러스, 트로이 목마, 악성 프로그램 공격, 네트워크 혼잡, 시스템 불안정, 시스템 또는 장비 장애, 통신 장애, 은행 사유, 타사 서비스 장애 또는 정부 조치로 인한 경우
  7. 회사의 귀책사유가 아닌 기타 사유

제6조 개인정보 수집, 사용, 공유 및 보호
회사는 고객의 개인정보 보호를 중요시하며, 고객의 정보 및 개인정보 보호는 회사의 기본 원칙입니다. 회사는 <Assura Asia 개인정보처리방침>에 따라 고객의 정보를 수집, 저장, 보호, 사용 및 제공을 시행합니다. 이 원칙은 해당 서비스에 대한 별도의 개인정보처리방침이 있거나 해당 사용자 서비스 계약에 특약이 있는 경우를 제외하고 보험 중개 플랫폼의 모든 서비스에 적용됩니다. 서비스를 이용하기 전에 이 약관의 모든 내용을 반드시 읽어보시기 바랍니다. 이 약관의 내용 및 이 페이지에서 제공하는 정보에 대해 궁금한 점이 있는 경우 후속 조작을 중단하고 이 규칙에 게시된 정보 처리자에 연락하여 답변 및 설명을 제공받으시기 바랍니다.

제7조 약관 변경, 해지, 종료 및 권리와 의무의 이전  1. 약관 변경  회사는 시장 변화 또는 운영상 필요에 따라 본 약관을 조정할 수 있으며, 약관의 조정은 홈페이지에 공지 또는 서신 등의 방법으로 공지한 후 공지한 날로부터 7자연일 이후부터 효력이 발생됩니다.  이 약관의 변경에 동의하지 않는 경우 즉시 서비스 이용을 중단하거나 고객센터를 통해 이 계약을 해지해야 하며, 그렇지 않은 경우 변경된 약관에 동의하고 수락한 것으로 간주합니다.  2. 약관 해지 및 종료  2.1 고객은 서비스 이용 과정에서 다음과 같이 해당하는 사유가 발생한 경우 회사는 이 약관을 해지할 수 있습니다.  2.1.1 타인의 명의를 부정하게 사용하거나 타인의 계정을 도용하여 서비스를 이용하는 경우  2.1.2 불법적인 목적으로 서비스를 사용하는 경우  2.1.3 플랫폼 시스템 및 정보를 침해할 수 있는 모든 행위  2.1.4 법률 및 규정 또는 본 약관을 위반하는 경우  2.1.5 규제 당국이 플랫폼에서 제공하는 서비스가 더 이상 관련 규제 요건을 준수하지 않는다고 판단하는 경우  2.2 상기 사유 외에도 회사는 위험 및 사업 운영에 따라 고객에 대한 특정 서비스의 제공을 종료할 수 있으며, 이 경우 회사는 이를 적절히 공지 또는 통지합니다. 이는 정상적인 비즈니스 의사 결정 행위이므로 이로 인해 고객이 서비스를 이용할 수 없거나 서비스가 제한되는 경우, 고객은 이에 대해 회사가 책임을 지지 않음을 이해합니다.  2.3 권리 및 의무의 이전: 회사는 서비스의 필요에 따라 이행 주체를 변경하거나 추가할 수 있습니다. 고객이 서비스를 계속 이용하는 경우, 고객은 변경된 주체 또는 새로 추가된 주체를 고객과의 이행 상대방으로 동의한 것으로 간주합니다. 회사는 고객의 서비스 이용에 부정적인 영향을 미치지 않는다는 전제 하에 본 약관에 따른 회사의 권리 및 의무의 전부 또는 일부를 별도의 통지나 고객의 동의 없이 제3자에게 이전할 수 있습니다.

제8조 분쟁 조정
본 약관의 체결, 유효성, 해석 및 이행과 분쟁의 해결은 관련 법률에 근거합니다. 본 약관의 이행 기간 동안 약관으로 인해 또는 약관과 관련하여 발생하는 모든 분쟁 또는 논쟁은 당사자들이 일차적으로 우호적인 협의를 통해 해결해야 합니다. 협의가 실패할 경우, 양 당사자는 해당 분쟁을 피고의 소재지 또는 양 당사자가 합의하는 관할 법원 또는 중재 기관에 제출하여 관련 법률에 따라 해결하는 데 동의합니다.

제9조 통지
본 약관의 이행 과정에서 회사는 고객에게 우편, 플랫폼 내 공지, 이메일, 서신, 휴대폰 문자 메시지 및 기타 수단을 포함한 서면 통지를 발송합니다. 회사가 고객에게 우편으로 서면 통지를 발송하는 경우, 회사는 고객이 플랫폼에 등록한 통신 주소로 우편물을 발송한 후 3자연일에 송달한 것으로 간주합니다. 서면 통지가 플랫폼의 공지, 보험 관련 공지, 이메일, 휴대폰 문자 메시지 등과 같은 전자적 수단으로 발송되는 경우, 통지가 성공적으로 전송된 시점에 발송된 것으로 간주합니다.

제10조 기타
  1. 본 약관에서 약관의 문맥에 달리 별도로 규정하는 경우:  본 약관에 대한 참조에는 본 약관과 그 부속서, 또한 이를 수정 또는 보완하는 모든 문서가 포함됩니다.  약관 및 첨부파일에 대한 언급은 본 계약의 약관 및 첨부파일에만 적용됩니다.  2. 본 약관의 제목은 편의를 위한 것으로서 본 약관의 해석을 구성하지 않으며 제목 아래 조항의 내용 및 범위를 제한하지 않습니다.  3. 본 약관의 첨부파일 및 보충 자료, 수정 또는 변경 사항은 본 약관의 필수적인 부분이며 약관의 본문과 동일한 법적 효력을 갖습니다.`,
}